import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import Congratulations from '../../../../assets/images/Congratulations.png';
import { ImgWebp } from '../../ImgWeb';
import { ButtonClassNames, GlobalRouteNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';

interface EndTourProps {
  handleProceed: (skip?: boolean) => void;
  handleClose: () => void;
}

export const ProductTourEnd: FC<EndTourProps> = ({ handleProceed, handleClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery('(max-width:767px)');

  const handleStart = () => {
    if (pathname !== GlobalRouteNames.HomePage) {
      history.push(GlobalRouteNames.HomePage);
    }
    handleProceed();
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header" style={{ textAlign: 'center' }}>
        <article className="modals__header__title">{t('productTour.successTitle')}</article>
        <p className="modals__header__description">{t('productTour.successDescription')}</p>
        <ImgWebp fallback={Congratulations} alt="Congratulations" className="img" />
      </div>
      <div
        className="modals__btn-group"
        style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', whiteSpace: !isMobile ? 'nowrap' : 'normal' }}
      >
        <CustomMUIButton
          label={t('productTour.startOver')}
          handleClick={handleStart}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('productTour.last')}
          handleClick={handleClose}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
